import { SystemIconModule } from './../system-icon/system-icon.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertComponent } from './alert/alert.component';



@NgModule({
  declarations: [
    AlertComponent
  ],
  imports: [
    CommonModule,
    SystemIconModule
  ],
  exports: [
    AlertComponent
  ]
})
export class AlertModule { }
